// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import { WebhookHeader, WebhookHeaderFromJSON, WebhookHeaderToJSON } from "./";

/**
 *
 * @export
 * @interface WebhookDeliveryAttempt
 */
export interface WebhookDeliveryAttempt {
  /**
   *
   * @type {number}
   * @memberof WebhookDeliveryAttempt
   */
  attempt: number;
  /**
   *
   * @type {number}
   * @memberof WebhookDeliveryAttempt
   */
  secretVersion: number;
  /**
   *
   * @type {string}
   * @memberof WebhookDeliveryAttempt
   */
  startedAt: string;
  /**
   *
   * @type {string}
   * @memberof WebhookDeliveryAttempt
   */
  completedAt: string;
  /**
   *
   * @type {number}
   * @memberof WebhookDeliveryAttempt
   */
  durationMs: number;
  /**
   * Destination with sensitive query values redacted.
   * @type {string}
   * @memberof WebhookDeliveryAttempt
   */
  requestUrl: string;
  /**
   *
   * @type {Array<WebhookHeader>}
   * @memberof WebhookDeliveryAttempt
   */
  requestHeaders: Array<WebhookHeader>;
  /**
   * Redacted JSON preview.
   * @type {string}
   * @memberof WebhookDeliveryAttempt
   */
  requestBody: string;
  /**
   *
   * @type {boolean}
   * @memberof WebhookDeliveryAttempt
   */
  requestTruncated: boolean;
  /**
   *
   * @type {number}
   * @memberof WebhookDeliveryAttempt
   */
  responseStatus: number;
  /**
   *
   * @type {Array<WebhookHeader>}
   * @memberof WebhookDeliveryAttempt
   */
  responseHeaders: Array<WebhookHeader>;
  /**
   * Escaped/redacted response preview, never executed as HTML.
   * @type {string}
   * @memberof WebhookDeliveryAttempt
   */
  responseBody: string;
  /**
   *
   * @type {boolean}
   * @memberof WebhookDeliveryAttempt
   */
  responseTruncated: boolean;
  /**
   *
   * @type {string}
   * @memberof WebhookDeliveryAttempt
   */
  errorKind: WebhookDeliveryAttemptErrorKindEnum;
  /**
   *
   * @type {string}
   * @memberof WebhookDeliveryAttempt
   */
  error: string;
}

export function WebhookDeliveryAttemptFromJSON(
  json: any
): WebhookDeliveryAttempt {
  return {
    attempt: json["attempt"],
    secretVersion: json["secret_version"],
    startedAt: json["started_at"],
    completedAt: json["completed_at"],
    durationMs: json["duration_ms"],
    requestUrl: json["request_url"],
    requestHeaders: (json["request_headers"] as Array<any>).map(
      WebhookHeaderFromJSON
    ),
    requestBody: json["request_body"],
    requestTruncated: json["request_truncated"],
    responseStatus: json["response_status"],
    responseHeaders: (json["response_headers"] as Array<any>).map(
      WebhookHeaderFromJSON
    ),
    responseBody: json["response_body"],
    responseTruncated: json["response_truncated"],
    errorKind: json["error_kind"],
    error: json["error"],
  };
}

export function WebhookDeliveryAttemptToJSON(
  value?: WebhookDeliveryAttempt
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    attempt: value.attempt,
    secret_version: value.secretVersion,
    started_at: value.startedAt,
    completed_at: value.completedAt,
    duration_ms: value.durationMs,
    request_url: value.requestUrl,
    request_headers: (value.requestHeaders as Array<any>).map(
      WebhookHeaderToJSON
    ),
    request_body: value.requestBody,
    request_truncated: value.requestTruncated,
    response_status: value.responseStatus,
    response_headers: (value.responseHeaders as Array<any>).map(
      WebhookHeaderToJSON
    ),
    response_body: value.responseBody,
    response_truncated: value.responseTruncated,
    error_kind: value.errorKind,
    error: value.error,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum WebhookDeliveryAttemptErrorKindEnum {
  Network = "network",
  Timeout = "timeout",
  Tls = "tls",
  Http = "http",
  DestinationValidation = "destination_validation",
  Cancelled = "cancelled",
}
